<script>
	// Stores 
	import { alt, mailAtendimento, textPoliticaCheck } from '../store.js';
	import { afterUpdate } from 'svelte';

	import { navigate } from "svelte-routing";
	import FormItem from "../components/FormItem.svelte";

	export let fields       = [];
	export let subjectTitle = 'Contato';
	export let subject      = subjectTitle + " | " + $alt;
	export let destiny      = $mailAtendimento;
	export let formId       = 'frm' + Math.random().toString().substring(2);
	export let htmlbody     = true;
	export let category     = '';
	export let message      = '';
	export let formclass    = '';
	export let buttonText    = 'Enviar';
	export let buttonClass    = 'btn btn-primary';
	export let boxContato   = false;

	let loading = false;

	let lgpdCheck = {
		title:  $textPoliticaCheck,
		name:   'lgpdcheck',
		required: 'required',
		type: 'checkbox',
		rowclass: 'lgpdcheck'
	};

	fields = [...fields, lgpdCheck];

	if (message.length == 0) {
		message = buildMessage();
	}

	function buildMessage() {
		message = '';
		for (const field of fields) {
			if (!htmlbody) {
				message += `${field.title}: {${field.name}}\n`;
			} else {
				message += `<p><b>${field.title}:</b> {${field.name}}</p>\n`				;
			}
		}

		if (!htmlbody) {
			message += '\n\n{info}';
		} else {
			message += '<hr /><br/><br/><p>{info}</p>';
		}
	}
	async function send() 
	{
		let parameters = {
			acc: 1,
			htmlbody: htmlbody,
			sub: 'b64' + EncodeBase64(subject),
			to: destiny.length > 0 ? destiny:document.querySelector(`#${formId} [name=destino]`).value,
			category: category,
			message: 'b64' + EncodeBase64(getMessage())
		};

		if (document.querySelector(`#${formId} [name=nome]`) != null) {
			parameters.nome = document.querySelector(`#${formId} [name=nome]`).value;
			window.store.set('field.nome', parameters.nome);
		}

		if (document.querySelector(`#${formId} [name=telefone]`) != null) {
			parameters.telefone = document.querySelector(`#${formId} [name=telefone]`).value;
			window.store.set('field.telefone', parameters.telefone);
		}

		if (document.querySelector(`#${formId} [name=email]`) != null) {
			parameters.email = document.querySelector(`#${formId} [name=email]`).value;
			window.store.set('field.email', parameters.email);
		}
		
		let fileInput = fields.find(i => i.type == "fileinput");
		if (fileInput != null && document.querySelector(`#${formId} #${fileInput.name}Guid`) != null) {
			parameters.attachmentGuid = document.querySelector(`#${formId} #${fileInput.name}Guid`).value;

			let currentCount = jQuery(`#${formId} #${fileInput.name}`).fileinput('getFrames').length;
			if (currentCount < fileInput.minFileCount) {
				return Promise.resolve({Error: true, Message: `Informe pelo menos ${fileInput.minFileCount} ${(fileInput.minFileCount == 1 ? "anexo": "anexos")}`});
			}
		}

		let url = `${atria.mainURL}/Services/Mail/Send.aspx?mode=realties&callback=null&${Object.entries(parameters).map(e=>`${e[0]}=${e[1]}`).join('&')}`;
		let response = await fetch(url, {
			method: 'GET',
			mode: 'cors'
		});

		Promise.resolve(await response.json());
	}
	async function trySend() {
		document.querySelector(`#${formId}`).classList.add('validated');
		let erros = document.querySelectorAll(`#${formId} input:invalid, #${formId} textarea:invalid`);
		if (erros.length > 0) {
			const label = fields.find(l=>l.name == erros[0].getAttribute('id')).title;

			//document.querySelector('html').scrollTop = 0;
			jQuery('html, body').animate({
				scrollTop: erros[0].offsetTop + jQuery('header').innerHeight()
			}, 200);

			if (erros[0].getAttribute('name') === 'lgpdcheck') {
				alert('Para prosseguir, verifique e marque que está de acordo com a nossa política de privacidade.');
			} else {
				alert(`Preencha o campo '${label}'`);
			}
			
			return;
		}

		loading = true;

		send().then(json => {
			loading = false;
			if (json != undefined && json != null && json.Error) {
				alert(json.Message);
			} else {
				navigate("/obrigado", { replace: true });
			}          
		}).catch(ex => {
			loading = false;
			alert("Ocorreu um erro! Por favor, tente novamente mais tarde.");
			console.error(ex);
		});

		return false;
	}
	function getMessage() {
		let html = message;
		
		// //Checkbox
		// for (let input of document.querySelectorAll(`#${formId} input[type=checkbox]`)) {
		//     console.log(input);
		// }

		// //Radio
		// for (let input of document.querySelectorAll(`#${formId} input[type=radio]`)) {
		//     console.log(input);
		// }

		//inputs
		for (let label of document.querySelectorAll(`#${formId} label[for]`)) {
			const input = document.querySelector(`#${formId} [name='${label.getAttribute('for')}']`);
			if (document.querySelector(`#${formId} [name='${label.getAttribute('for')}']`) != null) {
				html = html.replaceAll(`{${input.name}}`, input.value);
			}
		}

		//hidden
		for (let input of document.querySelectorAll(`#${formId} input[type=hidden]`)) {
			html = html.replaceAll(`{${input.name}}`, input.value);
		}
		
		html = html.replaceAll('{info}', navigator.userAgent);
		return html;
	}

	// Máscaras
	jQuery(document).ready(()=>{
		jQuery('.mask-cpf').mask('000.000.000-00', {reverse: true});
		jQuery('.mask-cep').mask('00000-000');
		jQuery('.mask-telefone').mask('(00) 00000-0000');
		jQuery('.mask-valor').mask("#.##0,00", {reverse: true});
		jQuery('.mask-number').mask("#.##0", {reverse: true});
		jQuery('.mask-data').mask("00/00/0000");	        
	});    
</script>
<form id={formId} class="formulario {formclass}" novalidate on:submit|preventDefault={trySend}>
{#if boxContato == false}    
	{#each fields as field}
		<FormItem {...field} />
	{/each}
	<div class="w-100 text-center">
		{#if loading}
		<button id="btn-send" class="{buttonClass}" type="button" disabled="disabled"><i class="fal fa-spinner-third fa-spin"></i></button>
		{:else}
		<button id="btn-send" class="{buttonClass}" type="submit">{buttonText}</button>
		{/if}
	</div>
{:else}
	{#each fields as field}
		<FormItem {...field} />
	{/each}
	<div class="w-100 text-center">
		{#if loading}
		<button id="btn-send" class="{buttonClass} w-100 mb-10" type="button" disabled="disabled"><i class="fal fa-spinner-third fa-spin"></i></button>
		{:else}
		<button id="btn-send" class="{buttonClass} w-100 mb-10">{buttonText}</button>
		{/if}
	</div>
{/if}
</form>